import BaseModel from './BaseModel'

export default class WholesaleReceivable extends BaseModel {
  // ... WholesaleReceivable-specific methods or overrides ...
}
